/**
 * Agrupa las tools del MCP como la doc de Meta.  (spec 039 · FR-004)
 * No es un segundo contrato: si el MCP manda un nombre nuevo, cae en «Otras».
 */
export const DOC_MCP =
    'https://developers.facebook.com/documentation/mcp/whatsapp-business-tools-mcp'

export const TOOL_ENVIAR = 'whatsapp_biz_send_message'
export const TOOL_SYSTEM_USER = 'whatsapp_biz_system_user_token'

export const TOOLS_DISCOVERY = [
    'whatsapp_biz_businesses',
    'whatsapp_biz_accounts',
    'whatsapp_biz_phone_numbers',
] as const

export interface HerramientaMcp {
    name: string
    description?: string
    inputSchema?: Record<string, unknown>
}

export interface GrupoTools {
    id: string
    titulo: string
    tools: HerramientaMcp[]
}

const ORDEN: Array<{ id: string; titulo: string; pred: (n: string) => boolean }> = [
    {
        id: 'discovery',
        titulo: 'Descubrimiento',
        pred: (n) => (TOOLS_DISCOVERY as readonly string[]).includes(n),
    },
    {
        id: 'numeros',
        titulo: 'Alta de número',
        pred: (n) => /add_phone|verification_code|verify_phone|register_phone/.test(n),
    },
    {
        id: 'plantillas',
        titulo: 'Plantillas',
        pred: (n) => /template/.test(n),
    },
    {
        id: 'mensajes',
        titulo: 'Mensajes',
        pred: (n) => n === TOOL_ENVIAR || /send_message/.test(n),
    },
    {
        id: 'webhooks',
        titulo: 'Webhooks',
        pred: (n) => /webhook/.test(n),
    },
    {
        id: 'cuenta',
        titulo: 'Cuenta',
        pred: (n) => /payments|verify_business|system_user/.test(n),
    },
]

export function agruparHerramientas(tools: HerramientaMcp[]): GrupoTools[] {
    const usados = new Set<string>()
    const grupos: GrupoTools[] = []
    for (const g of ORDEN) {
        const lista = tools.filter((t) => g.pred(t.name))
        for (const t of lista) usados.add(t.name)
        if (lista.length) grupos.push({ id: g.id, titulo: g.titulo, tools: lista })
    }
    const otras = tools.filter((t) => !usados.has(t.name))
    if (otras.length) grupos.push({ id: 'otras', titulo: 'Otras', tools: otras })
    return grupos
}

export function exigeConfirmarEnvio(name: string): boolean {
    return name === TOOL_ENVIAR
}

export function esSystemUserToken(name: string): boolean {
    return name === TOOL_SYSTEM_USER
}

/** Campos simples del JSON Schema que manda tools/list. */
export function camposDeSchema(
    schema: Record<string, unknown> | undefined,
): Array<{ name: string; type: string; required: boolean; description?: string }> {
    if (!schema || schema['type'] !== 'object') return []
    const props = schema['properties']
    if (!props || typeof props !== 'object') return []
    const required = Array.isArray(schema['required'])
        ? (schema['required'] as unknown[]).filter((x): x is string => typeof x === 'string')
        : []
    return Object.entries(props as Record<string, Record<string, unknown>>).map(([name, p]) => ({
        name,
        type: typeof p['type'] === 'string' ? p['type'] : 'string',
        required: required.includes(name),
        ...(typeof p['description'] === 'string' ? { description: p['description'] } : {}),
    }))
}

export function destinoDeEnvio(args: Record<string, unknown>): string {
    for (const k of Object.keys(args)) {
        if (/to|phone|recipient|wa_id|destination/i.test(k) && typeof args[k] === 'string' && args[k]) {
            return String(args[k])
        }
    }
    return ''
}
